import React, { useState } from 'react';
import { Section } from './Shared';
import { CheckSquare, ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Cómo recibo el programa después de comprar?',
  answer: 'Apenas se acredita el pago, recibís un email con acceso inmediato al programa completo, los bonos y todos los materiales descargables. No tenés que esperar nada.'
}, {
  question: '¿Necesito experiencia previa en redes?',
  answer: 'No, para nada. El programa está diseñado desde cero. No importa si nunca publicaste nada o si tenés 0 seguidores. Te guiamos paso a paso.'
}, {
  question: '¿Sirve para Instagram y TikTok?',
  answer: 'Sí. Las estrategias, ideas de contenido y el sistema de planificación funcionan para ambas plataformas. Podés aplicarlo en la que prefieras o en las dos.'
}, {
  question: '¿Cuánto tiempo tengo acceso al programa?',
  answer: 'Acceso de por vida. Una vez que comprás, el programa es tuyo para siempre. Podés verlo a tu ritmo, repetirlo y consultarlo cuando quieras.'
}, {
  question: '¿Qué pasa si no me gusta?',
  answer: 'Como es un producto digital de acceso inmediato, no realizamos reembolsos. Pero si tenés algún problema con la descarga o el acceso, te lo solucionamos al instante.'
}, {
  question: '¿Puedo verlo desde el celular?',
  answer: 'Sí, es 100% compatible con celular, tablet y computadora. Podés acceder desde cualquier dispositivo con conexión a internet.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };
  return <Section className="bg-white" data-id="element-197">
      <div className="max-w-3xl mx-auto" data-id="element-198">
        <h2 className="font-montserrat font-black text-3xl md:text-5xl uppercase leading-tight text-center mb-12" data-id="element-199">
          Preguntas Frecuentes
        </h2>

        <div className="divide-y divide-gray-200 border-t border-b border-gray-200" data-id="element-200">
          {faqs.map((faq, idx) => <div key={idx} data-id="element-201">
              <button onClick={() => toggle(idx)} className="w-full flex items-center gap-4 py-5 px-2 text-left group" data-id="element-202">
                <CheckSquare className="w-5 h-5 text-black shrink-0" data-id="element-203" />
                <span className="font-montserrat font-bold text-base md:text-lg text-black flex-1" data-id="element-204">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === idx ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-205">
                  <ChevronDownIcon className="w-5 h-5 text-gray-400 shrink-0" data-id="element-206" />
                </motion.div>
              </button>
              <AnimatePresence initial={false} data-id="element-207">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-208">
                    <p className="font-opensans text-gray-600 text-base leading-relaxed pb-5 pl-11 pr-4" data-id="element-209">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}